export default "__VITE_ASSET__KoG6I5vW__"